import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { L10n } from '~src/commonInfra/L10n/L10n';

export type DeleteDataConnectClusterDialogProps = Readonly<{
  clusterName: string;
  hasNodes: boolean;
  nodes: Node[];
  hasPools: boolean;
}>
export type DeleteDataConnectClusterDialogState = Readonly<{
  isPending: boolean;
}>

const dialogClass = style({ marginBottom: 30, whiteSpace: 'break-spaces' });
const listClass = style({ maxHeight: 100, overflowY: 'auto', overflowX: 'clip' });
const listItemClass = style({ listStyleType: 'none', paddingInlineStart: TabStyles.Spacing.LargeSpace });

export function DeleteDataConnectClusterDialogBody(props: DeleteDataConnectClusterDialogProps) {
  return (
    <div className={dialogClass}>
      <div>{getDeleteClusterMessage(props)}</div>
      <div className={listClass}>
        {props.hasNodes &&
          <ul id='nodeList' className={listItemClass}>
            {props.nodes.map(node => {
              return <li key={node.nodeName}>{node.nodeName}</li>;
            })}
          </ul>
        }
      </div>
    </div>
  );
}

function getDeleteClusterMessage(props: DeleteDataConnectClusterDialogProps) {
  let message = Messages.dataConnectSiteSettingsDeleteClusterWarning({ CLUSTER_NAME: L10n.elideIfLong(props.clusterName) });
  if (props.hasNodes) {
    message += ' ' + Messages.dataConnectSiteSettingsDeleteClusterWithNodes();
  }
  return message;
}
